import ExecutePopupWrongTick from './ExecutePopupWrongTick';

export default ExecutePopupWrongTick;
